import { remixArticles } from "@/mocks/home";

export default function RemixSection() {
  const [featured, ...rest] = remixArticles;

  return (
    <section id="remix" className="w-full scroll-mt-24 bg-background-50 py-14 md:py-20" aria-labelledby="remix-title">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-secondary-700">
              <i className="ri-quill-pen-line text-sm" aria-hidden="true" />
              FAN REMIX · 二创解读
            </span>
            <h2 id="remix-title" className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              换个角度，把瓜吃出层次
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              不站队也能有收获。这里的解读基于公开信息，帮你看清一件事是怎么被推上热门、又是怎么被误读的。
            </p>
          </div>
          <a
            href="#faq"
            className="flex w-fit items-center gap-1.5 whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700"
          >
            投稿你的解读
            <i className="ri-arrow-right-line text-base" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1.1fr_1fr]">
          <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative h-[240px] w-full overflow-hidden md:h-[300px]">
              <img
                src={featured.cover}
                alt={`${featured.title} - 网爆黑料二创解读封面`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-primary-950">
                {featured.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-7">
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="font-bold text-foreground-800">{featured.author}</span>
                <span className="h-3 w-px bg-background-300" aria-hidden="true" />
                <span>阅读约 {featured.readTime}</span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
              <span className="mt-6 flex items-center gap-1.5 text-sm font-bold text-primary-600 transition-colors group-hover:text-primary-700">
                阅读全文
                <i className="ri-arrow-right-line text-base" aria-hidden="true" />
              </span>
            </div>
          </article>

          <div className="flex flex-col gap-6">
            {rest.map((article) => (
              <article
                key={article.id}
                className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300 sm:flex-row md:p-5"
              >
                <div className="h-[140px] w-full shrink-0 overflow-hidden rounded-md sm:h-[120px] sm:w-[160px]">
                  <img
                    src={article.cover}
                    alt={`${article.title} - 二创解读配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col">
                  <span className="w-fit rounded-md bg-secondary-50 px-2 py-0.5 text-xs font-bold text-secondary-800">
                    {article.tag}
                  </span>
                  <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-secondary-700 md:text-lg">
                    {article.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
                  <div className="mt-auto flex items-center gap-3 pt-3 text-xs text-foreground-500">
                    <span className="font-medium text-foreground-700">{article.author}</span>
                    <span>阅读约 {article.readTime}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}